module.exports = "./img/d07dcdab02c8b2d194ecca68be827ecc.jpg";